<template>
  <modal 
    name="forum-item-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'640px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        Latest announcements from {{ getAppName }} Forum
      </div>

      <a href="#"
        v-on:click.prevent="close"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">

      <div class="bg-gray-200 text-sm p-3 leading-normal border border-gray-600 rounded">
        Did you know {{ getAppName }} has a forum? It's a community of {{ getAppName }} users discussing a wide variety of topics
        including latest product features and updates, user requests and broking industry news &amp; trends.
        The following are the latest product announcements made in that forum. Please note that forum access is currently limited
        to users with paid plans.
      </div>

      <template v-for="(item, index) in items">
        <div class="mt-6">
          <div class="text-base font-semibold">
            <a :href="item.content_url" target="_blank" class="underline text-blue-600">{{ item.title }}</a>
          </div>

          <div class="mt-1 text-sm text-gray-600">{{ formatDate(item.created_at, "YYYY-MM-DD HH:mm", "DD/MM/YY") }}</div>

          <div class="mt-2 text-base">
            <!-- {{ shorten(item.snippet, 200) }} -->
            {{ shorten(item.snippet, 200) }}
            <a :href="item.content_url" target="_blank" class="ml-3 text-gray-600 text-sm hover:underline">Read more</a>
          </div>
        </div>
      </template>

      <div class="button-line">
        <SubmitButton :onClick="close" :loading="loading" label="Close" :isFullWidth="true" />
      </div>
    </div>
  </modal>
</template>

<script>
  import moment         from 'moment'
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton   from '@/shared/components/form/SubmitButton'

  export default {

    props : {
      setLastForumItemChecked : {
        type    : Function,
        required: true
      }
    },

    components : {
      SubmitButton
    },

    data() {
      return {
        reason : null,
        loading: false,
        items  : null
      }
    },

    methods : {
      
      beforeOpen(event) {
        this.loading = false
        this.items   = event.params.items
      },

      opened(event) {
        this.$cookies.set('forum-item-last-checked-at', moment().format("YYYY-MM-DD HH:mm:ss"))
      },

      beforeClose() {
        this.setLastForumItemChecked()
      },

      close() {
        this.$modal.hide('forum-item-modal')
      },

      upgrade() {
        window.open('https://forum.brokerpad.com.au/auth/mo/register?value=' + this.$store.state.user.email, '_blank')
      },
    }
  }
</script>